"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTopBannerAndIntroTextData = void 0;
var _mui = require("@ori-ui/mui");
var _fetching = require("@ori/fetching");
var _presentationUtils = require("@ori/presentation-utils");
var _staticApiClientReact = require("@ori/static-api-client-react");
const getTopBannerAndIntroTextData = async ({
  fallbackBackgroundColor,
  fallbackTextColor,
  language,
  pageId,
  staticApiClient,
  tenant
}) => {
  const response = await (0, _staticApiClientReact.getTenantApplicationsEditorialHeaders)(staticApiClient, tenant, {
    headerIds: [pageId],
    lang: language
  }, {
    validateStatus: _fetching.validateStatus
  });
  const data = (0, _fetching.handleResponse)(response, {
    onError: () => null,
    onSuccess: res => res.data
  });
  const firstBanner = data?.collection[0];
  const topBannerData = {
    backgroundColor: (0, _presentationUtils.mapBackendColorToTheme)({
      theme: _mui.theme,
      backendColor: firstBanner?.backgroundStorybookColor,
      fallBackColor: fallbackBackgroundColor
    }),
    imageUrl: firstBanner?.imageUrl ?? null,
    textColor: (0, _presentationUtils.mapBackendColorToTheme)({
      theme: _mui.theme,
      backendColor: firstBanner?.headlineStorybookColor,
      fallBackColor: fallbackTextColor
    }),
    title: firstBanner?.headline ?? null,
    extraLongHeadline: firstBanner?.extraLongHeadline ?? false
  };
  return {
    introText: firstBanner?.text ?? null,
    topBannerData
  };
};
exports.getTopBannerAndIntroTextData = getTopBannerAndIntroTextData;
//# sourceMappingURL=getTopBannerAndIntroTextData.js.map